<ng-container>
    <div class="card mt-20">
        <div class="body">
            <table mat-table [dataSource]="acceptedOfferList" matSort matSortActive="UtilityName" matSortDisableClear matSortDirection="asc" class="offer-summmary-table">
                <ng-container matColumnDef="#">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
                    <td mat-cell *matCellDef="let element, let i =index">{{currentStart+i+1}}</td>
                </ng-container>
                <ng-container matColumnDef="Type">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                    <td mat-cell *matCellDef="let element">
                        @if (element.sellOffer!=null) {
                        <span>Seller Offer</span>
                        }@if (element.sellOffer==null) {
                        <span>buyer order</span>
                        }
                    </td>
                </ng-container>
                <ng-container matColumnDef="UtilityName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Utility</th>
                    <td mat-cell *matCellDef="let element"> {{element.utility.name}} </td>
                </ng-container>
                <ng-container matColumnDef="LoadZone">
                    <th mat-header-cell *matHeaderCellDef>Load Zone</th>
                    <td mat-cell *matCellDef="let element"> {{element.loadZone.name}} </td>
                </ng-container>
                <ng-container matColumnDef="RateClass">
                    <th mat-header-cell *matHeaderCellDef>Rate Class</th>
                    <td mat-cell *matCellDef="let element"> {{element.rateClass.name}} </td>
                </ng-container>
                <ng-container matColumnDef="TermFrom">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Starting On</th>
                    <td mat-cell *matCellDef="let element"> {{element.termFrom | date:'shortDate'}} </td>
                </ng-container>
                <ng-container matColumnDef="TermTo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Ending On</th>
                    <td mat-cell *matCellDef="let element"> {{element.termTo | date:'shortDate'}} </td>
                </ng-container>
                <ng-container matColumnDef="BuyOfferPrice">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Buyer Order Price</th>
                    <td mat-cell *matCellDef="let element">
                        @if (element.buyOfferPrice==null||element.buyOfferPrice==0) {
                        <span>-</span>
                        }@if (element.buyOfferPrice>0) {
                        <span>{{element.buyOfferPrice | currency:'USD':'symbol':'1.5-5'}}/kWh</span>
                        }
                    </td>
                </ng-container>
                <ng-container matColumnDef="SellOfferPrice">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Seller Offer Price</th>
                    <td mat-cell *matCellDef="let element">
                        @if (element.sellOfferPrice==null||element.sellOfferPrice==0) {
                        <span>-</span>
                        }@if (element.sellOfferPrice>0) {
                        <span>{{element.sellOfferPrice | currency:'USD':'symbol':'1.5-5'}}/kWh</span>
                        }
                    </td>
                </ng-container>
                <ng-container matColumnDef="Fee">
                    <th mat-header-cell *matHeaderCellDef>License Fee</th>
                    <td mat-cell *matCellDef="let element">
                        @if (element.fee==null||element.fee==0) {
                        <span>-</span>
                        }@if (element.fee>0) {
                        <span>{{element.fee | currency:'USD':'symbol':'1.5-5'}}/kWh</span>
                        }
                    </td>
                </ng-container>
                <ng-container matColumnDef="SalesPrice">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Sales Price <div class="notifiedIconSmall cursor-pointer" (click)="iIconPopup('Sales Price includes Licence Fee. Seller\'s price is estimated as Sales Price minus License Fee.')"></div></th>
                    <td mat-cell *matCellDef="let element"> {{element.getSalesPrice() | currency:'USD':'symbol':'1.5-5'}}/kWh </td>
                </ng-container>
                <ng-container matColumnDef="TermRescission">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Rescission Deadline</th>
                    <td mat-cell *matCellDef="let element">
                        @if (element.canBeCancelledUntil!=null) {
                        <span>{{element.canBeCancelledUntil | date:'shortDate'}} &#64; {{element.canBeCancelledUntil | date:'h:mm:ss'}} EST</span>
                        }
                        @if (element.canBeCancelledUntil==null) {
                        <span>-</span>
                        }
                    </td>
                </ng-container>
                <ng-container matColumnDef="AccountsCount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Accounts</th>
                    <td mat-cell *matCellDef="let element"> {{element.accounts.length}} </td>
                </ng-container>
                <ng-container matColumnDef="BatchExport">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Exported in Batch</th>
                    <td mat-cell *matCellDef="let element">
                        @if (element.batchExport==null) {
                        <span>-</span>
                        }
                        @if (element.batchExport!=null) {
                        <a (click)="getBatchExportFile(element.batchExport.id)"><b>{{element.batchExport.id}}</b></a>
                        }
                    </td>
                </ng-container>
                <ng-container matColumnDef="Status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let element,let i = index">
                        @if (isDeclined(element.status)) {
                        <a (click)="verifyContract(element)"><b>Declined</b></a>
                        }
                        @if (isDeclinedByBuyer(element.status)) {
                        <a (click)="verifyContract(element)"><b>Cancelled</b></a>
                        }
                        @if (isRescission(element.status, element.canBeCancelled)) {
                        <a (click)="verifyContract(element)"><b>Rescission</b></a>
                        }
                        @if (isOpen(element.status)) {
                        <a (click)="viewContract(element)"><b>Confirmed</b></a>
                        }
                        @if (isPending(element.status)) {
                        <a (click)="verifyContract(element)"><b>Confirmed</b></a>
                        }
                        @if (isPendingVerification(element.status)) {
                        <a (click)="verifyContract(element)"><b>Pending</b></a>
                        }
                        @if (isDeclinedTimout(element.status)) {
                        <a (click)="verifyContract(element)"><b>Confirmation timeout</b></a>
                        }
                    </td>
                </ng-container>
                <ng-container matColumnDef="Download">
                    <th mat-header-cell *matHeaderCellDef>Download</th>
                    <td mat-cell *matCellDef="let element">
                        <a (click)="exportContract(element)" class="pdf-icon"></a>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row [class]="(row.isNewRecord)?'higlighted':''" (click)="markAcceptedOfferNotNew(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [hidePageSize]="true" [length]="total" showFirstLastButtons [pageSize]="RECS_PER_PAGE" aria-label="Select page"></mat-paginator>
        </div>
    </div>
</ng-container>